import axios from 'axios';
import axiosHelper from 'utils/axiosHelper';

/**
   * Liste des actions
 */
export const Actions = {
    FETCH_SUGGESTIONS_CLIENT_REQUEST: 'FETCH_SUGGESTIONS_CLIENT_REQUEST',
    FETCH_SUGGESTIONS_CLIENT_SUCCESS: 'FETCH_SUGGESTIONS_CLIENT_SUCCESS',
    FETCH_SUGGESTIONS_CLIENT_FAILURE: 'FETCH_SUGGESTIONS_CLIENT_FAILURE',

    FETCH_CLIENT_CONTACTS_REQUEST: 'FETCH_CLIENT_CONTACTS_REQUEST',
    FETCH_CLIENT_CONTACTS_SUCCESS: 'FETCH_CLIENT_CONTACTS_SUCCESS',
    FETCH_CLIENT_CONTACTS_FAILURE: 'FETCH_CLIENT_CONTACTS_FAILURE',

    SET_CLIENT_CONTACT: 'SET_CLIENT_CONTACT',

    CLEAR_SUGGESTIONS_CLIENT: 'CLEAR_SUGGESTIONS_CLIENT',

    SET_CLIENT_VALUE: 'SET_SUGGESTIONS_CLIENT_VALUE',
    CLEAR_CLIENT_VALUE: 'CLEAR_SUGGESTIONS_CLIENT_VALUE'
};

/**
 * ActionCreator pour FETCH_SUGGESTIONS_...
 */
const fetchSuggestionsClientRequest = (namespace) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_CLIENT_REQUEST}`
});
const fetchSuggestionsClientSuccess = (namespace, clients) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_CLIENT_SUCCESS}`,
    clients
});
const fetchSuggestionsClientFailure = (namespace, error) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_CLIENT_FAILURE}`,
    error
});

/**
 * ActionCreator pour la récuperation des données (suggestions)
 */
export const fetchSuggestionsClient = (namespace, searchValue, activitesAutorisees, activitesExclues) => async (dispatch) => {
    dispatch(fetchSuggestionsClientRequest(namespace));

    try {
        let params = {
            query: searchValue
        };

        if (activitesAutorisees !== null && activitesAutorisees !== undefined) {
            params = { ...params, activitesAutorisees: activitesAutorisees}
        }

        if (activitesExclues !== null && activitesExclues !== undefined) {
            params = { ...params, activitesExclues: activitesExclues }
        }

        let response = await axios.get('api/clients/suggestion', { params: params, paramsSerializer: axiosHelper.transformRequestOptions });

        dispatch(fetchSuggestionsClientSuccess(namespace, response.data));

    } catch (error) {
        dispatch(fetchSuggestionsClientFailure(namespace, error));
    }
};

/**
 * ActionCreator pour CLEAR_SUGGESTIONS_CLIENT
 */
export const clearSuggestionsClient = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_SUGGESTIONS_CLIENT}` });

/**
 * ActionCreator pour SET_CLIENT_VALUE
 */
export const setClientValue = (namespace, value, selectedId, chargerContact, chargerContactExclusionMotif = 0) => ({ type: `${namespace}/${Actions.SET_CLIENT_VALUE}`, value, selectedId, chargerContact, chargerContactExclusionMotif });

/**
 * ActionCreator pour CLEAR_CLIENT_VALUE
 */
export const clearClientValue = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_CLIENT_VALUE}` });

/**
 * ActionCreator pour FETCH_CLIENT_CONTACTS...
 */
const fetchClientContactsRequest = (namespace) => ({
    type: `${namespace}/${Actions.FETCH_CLIENT_CONTACTS_REQUEST}`
});
const fetchClientContactsSuccess = (namespace, contacts) => ({
    type: `${namespace}/${Actions.FETCH_CLIENT_CONTACTS_SUCCESS}`,
    contacts
});
const fetchClientContactsFailure = (namespace, error) => ({
    type: `${namespace}/${Actions.FETCH_CLIENT_CONTACTS_FAILURE}`,
    error
});

/**
 * ActionCreator pour la récuperation des données (contacts)
 */
export const fetchClientContacts = (namespace, clientId) => async (dispatch) => {
    dispatch(fetchClientContactsRequest(namespace));

    try {
        let response = await axios.get(`api/clients/${clientId}/contacts`);

        dispatch(fetchClientContactsSuccess(namespace, response.data));

    } catch (error) {
        dispatch(fetchClientContactsFailure(namespace, error));
    }
};

/**
 * ActionCreator pour SET_CLIENT_CONTACT
 */
export const setClientContact = (namespace, selectedId) => ({ type: `${namespace}/${Actions.SET_CLIENT_CONTACT}`, selectedId });
